module.exports = __webpack_public_path__ + "static/Why-c7846fafd44ce6c2922b56cec7e23747.png";